import React, { useMemo } from "react";
import AutoSizer from "react-virtualized-auto-sizer";
import { useChartColors } from "@hooks";
import { SparklineChart } from "../highcharts";

export interface AccountPreviewChartData {
  value: number;
  date: Date;
}

export interface AccountPreviewChartProps {
  chartData: AccountPreviewChartData[];
  isFetching: boolean;
  height?: number;
  strokeColor?: string;
}

export const AccountPreviewChart = ({
  chartData,
  strokeColor,
  isFetching,
  height = 48,
}: AccountPreviewChartProps) => {
  const chartColors = useChartColors("securitiesChart");
  const values = useMemo(() => chartData.map((d) => d.value), [chartData]);

  const trendColor =
    chartData.length >= 2 &&
    chartData[chartData.length - 1].value < chartData[0].value
      ? chartColors.negative
      : chartColors.positive;

  return (
    <AutoSizer>
      {({ width }) => (
        <SparklineChart
          data={values}
          color={strokeColor || trendColor}
          isLoading={isFetching}
          width={width}
          height={height}
        />
      )}
    </AutoSizer>
  );
};
